"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerGridCell = void 0;
var Utilities_1 = require("../../Utilities");
var ColorPickerGridCell_base_1 = require("./ColorPickerGridCell.base");
var ColorPickerGridCell_styles_1 = require("./ColorPickerGridCell.styles");
exports.ColorPickerGridCell = (0, Utilities_1.styled)(ColorPickerGridCell_base_1.ColorPickerGridCellBase, ColorPickerGridCell_styles_1.getStyles, undefined, { scope: 'ColorPickerGridCell' }, true);
//# sourceMappingURL=ColorPickerGridCell.js.map